// Modules
import { createAction, props } from '@ngrx/store';

// Interfaces
import {
  IDashboardGetAutoStatisticsRequest,
  IDashboardAutoStatisticsResponse,
} from '@shared/interfaces';

// ----------- Dashboard Actions -----------
// ---------------------------------------
export const reset = createAction('[Dashboard] - Reset');

export const getAutoStatisticsRequested = createAction(
  '[Dashboard] - Get Auto Statistics Requested',
  props<{ payload: IDashboardGetAutoStatisticsRequest }>()
);

export const getAutoStatisticsResponse = createAction(
  '[Dashboard] - Get Auto Statistics Response',
  props<{ payload: IDashboardAutoStatisticsResponse }>()
);
